import API from "../axiosConfig";

export const getSections = async () => {
  try {
    const response = await API.get("/sections");
    return response.data;
  } catch (error) {
    console.error("Error fetching sections:", error);
    throw error;
  }
};

export const getSectionById = async (id) => {
  try {
    const response = await API.get(`/sections/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSectionsByZoneId = async (zoneId) => {
  try {
    const response = await API.get("/sections/zone_id/" + zoneId);
    return response.data;
  } catch (error) {
    console.error("Error fetching sections:", error);
    throw error;
  }
};

export const createSection = async (sectionData) => {
  try {
    const response = await API.post("/sections", sectionData);
    return response.data;
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};

export const updateSection = async (sectionId, sectionData) => {
  try {
    const response = await API.put(`/sections/${sectionId}`, sectionData);
    return response.data;
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};

export const deleteSection = async (sectionId) => {
  try {
    const response = await API.delete(`/sections/${sectionId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting section:", error);
    throw error;
  }
};
